import React, { useRef, useState } from 'react';

import { ReactComponent as DownArrow } from '../../assets/icons/down-arrow.svg';

/**
 * Custom drop down component
 * @param {any} param0 - The param0
 * @param {any} param0.icon - The icon prop
 * @param {any} param0.arrowPosition - The arrowPosition prop
 * @param {any} param0.backgroundColor - The backgroundColor prop
 * @param {any} param0.label - The label prop
 * @param {any} param0.content - The content prop
 * @param {any} param0.open - The open prop
 * @param {any} param0.count - The count prop
 * @param {any} param0.height - The height prop
 * @param {any} param0.title - The title prop
 * @param {any} param0.description - The description prop
 * @returns {any} The result
 */
function CustomDropDown({
  icon,
  arrowPosition,
  backgroundColor,
  label,
  content,
  open,
  count,
  height,
  title,
  description,
}: {
  icon?: JSX.Element;
  arrowPosition?: 'left' | 'right';
  backgroundColor?: 'primary' | 'plain';
  label?: string;
  content: JSX.Element | null;
  open?: boolean;
  count?: number;
  height?: number;
  title?: string;
  description?: string;
}) {
  const [isOpen, setIsOpen] = useState(open);
  const contentReference = useRef<HTMLDivElement>(null);
  return (
    <div className={`custom-drop-down-wrap ${backgroundColor}`}>
      <div
        className={`custom-drop-down-container ${backgroundColor}`}
        style={{ height: height && `${height}px` }}
        onClick={() => setIsOpen((previous) => !previous)}
        role="presentation">
        {icon && icon}
        {arrowPosition === 'left' && (
          <div className={`custom-drop-down-arrow ${isOpen ? 'rotate' : ''}`}>
            <DownArrow />
          </div>
        )}
        <div className="custom-drop-down-label">
          {label && (
            <p className="label">
              {label} {count !== null && <span className="counts">{count}</span>}
            </p>
          )}
          {title && description && (
            <div className="title-and-description">
              <p className="title">{title}</p>
              <p className="description">{description}</p>
            </div>
          )}
          {arrowPosition === 'right' && (
            <div className={`custom-drop-down-arrow ${isOpen ? 'rotate' : ''}`}>
              <DownArrow />
            </div>
          )}
        </div>
      </div>
      <div
        className={`custom-drop-down-content ${isOpen ? 'open' : ''}`}
        style={{ maxHeight: isOpen ? contentReference.current?.scrollHeight : 0 }}
        ref={contentReference}>
        <div className="inner-content">{content}</div>
      </div>
    </div>
  );
}

export default CustomDropDown;

CustomDropDown.defaultProps = {
  icon: null,
  open: false,
  arrowPosition: 'left',
  backgroundColor: 'primary',
  count: null,
  height: 35,
  label: '',
  title: '',
  description: '',
};
